/* Scoped enhancement; normal product links remain usable without JavaScript. */
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-am-mosaic]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const viewport = root.querySelector('[data-mosaic-viewport]');
      const prev = root.querySelector('[data-mosaic-prev]'), next = root.querySelector('[data-mosaic-next]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => { prev.disabled = viewport.scrollLeft <= 1; next.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1; };
      prev.addEventListener('click', () => viewport.scrollBy({left:-viewport.clientWidth*.7,behavior:reduced.matches?'auto':'smooth'}));
      next.addEventListener('click', () => viewport.scrollBy({left:viewport.clientWidth*.7,behavior:reduced.matches?'auto':'smooth'}));
      viewport.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(viewport);
      let drag = null, moved = false;
      viewport.addEventListener('pointerdown', e => { if(e.pointerType !== 'mouse' || e.button || viewport.scrollWidth <= viewport.clientWidth) return; drag={x:e.clientX,left:viewport.scrollLeft}; moved=false; });
      viewport.addEventListener('pointermove', e => { if(!drag)return; const dx=e.clientX-drag.x; if(Math.abs(dx)>5){moved=true;viewport.classList.add('is-dragging');viewport.scrollLeft=drag.left-dx;e.preventDefault();} });
      const end=()=>{drag=null;viewport.classList.remove('is-dragging');};
      viewport.addEventListener('pointerup',end);viewport.addEventListener('pointerleave',end);viewport.addEventListener('pointercancel',end);
      viewport.addEventListener('dragstart',e=>e.preventDefault());
      viewport.addEventListener('click',e=>{if(moved){e.preventDefault();moved=false;}},true);
      update();
    });
    // Preserve alternate-template preview while following filters or submitting sort.
    const view = new URL(location.href).searchParams.get('view');
    if(view === 'editorial-collection') scope.querySelectorAll('[data-am-collection]').forEach(root => {
      root.querySelectorAll('form').forEach(form=>{if(!form.querySelector('[name="view"]')){const input=document.createElement('input');input.type='hidden';input.name='view';input.value=view;form.append(input);}});
      root.querySelectorAll('.am-facet__opt,.am-pill,.am-coll-clear,.am-pager a').forEach(link=>{const url=new URL(link.href);url.searchParams.set('view',view);link.href=url.href;});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
